<template>
  <div id="app">
    <keep-alive :include="cachedViews">
        <router-view class="res"></router-view>
      </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    cachedViews() {
      return this.$store.state.global.tagList
    }
  }
}
</script>
